export const projectDropdownI18nDe = {
    projects: "Projekte",
    findProjectPlaceholder: "Projekt finden",
};
